/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */
import { useEffect, useRef } from 'react';
import { uiPushClient } from '../clientInstance';

const { subscribe, unsubscribe } = uiPushClient;

export const useUiPushSubscription = (
  service,
  eventType,
  handler,
  enabled = true,
  { onError, onSubscribed, onUnsubscribed, onConnect, onDisconnect } = {}
) => {
  const handlersRef = useRef({});

  handlersRef.current = { handler, onError, onSubscribed, onUnsubscribed, onConnect, onDisconnect };

  useEffect(() => {
    if (!enabled || !service || !eventType) {
      return undefined;
    }

    const componentSubscriptionKey = subscribe(service, eventType, message => handlersRef.current?.handler?.(message), {
      onError: error => handlersRef.current?.onError?.(error),
      onSubscribed: info => handlersRef.current?.onSubscribed?.(info),
      onUnsubscribed: info => handlersRef.current?.onUnsubscribed?.(info),
      onConnect: info => handlersRef.current?.onConnect?.(info),
      onDisconnect: info => handlersRef.current?.onDisconnect?.(info),
    });

    return () => {
      unsubscribe(componentSubscriptionKey);
    };
  }, [service, eventType, enabled]);
};
